module.exports = __webpack_public_path__ + "img/P61-en.2d3ee861.png";